import { SxProps, Theme } from '@mui/system';

const styles = {
  serviceContainer: {
    pt: '15px',
  },
  tableContainer: {
    mt: '15px',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
